import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ContactSuggestion = _resolveComponent("ContactSuggestion")
  const _component_Icon = _resolveComponent("Icon")
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["shc-ddown", {error: $props.required && $options.empty}])
  }, [
    _createVNode(_component_el_autocomplete, {
      ref: "el_autocomplete",
      modelValue: $data.el_value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.el_value) = $event)),
      debounce: 500,
      "popper-class": "autocomplete-popper",
      teleported: $props.teleported,
      placeholder: $props.placeholder,
      "fetch-suggestions": $options.loadAsync,
      "value-key": "key",
      "fit-input-width": "",
      onInput: $options.onInput,
      onSelect: $options.onSelect
    }, {
      default: _withCtx(({ item }) => [
        _createVNode(_component_ContactSuggestion, {
          suggestion: item,
          style: {"padding":"0.55rem 2.4rem"}
        }, null, 8 /* PROPS */, ["suggestion"])
      ]),
      suffix: _withCtx(() => [
        ($data.el_value)
          ? (_openBlock(), _createBlock(_component_Icon, {
              key: 0,
              class: "pointer",
              size: "1.6rem",
              icon: "x-close",
              stroke: "var(--brand-700)",
              "stroke-width": "1",
              onClick: _cache[0] || (_cache[0] = $event => ($options.clear()))
            }))
          : (_openBlock(), _createBlock(_component_Icon, {
              key: 1,
              class: "pointer",
              size: "1.6rem",
              icon: "external-link",
              stroke: "var(--brand-200)",
              "stroke-width": "1"
            }))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "teleported", "placeholder", "fetch-suggestions", "onInput", "onSelect"])
  ], 2 /* CLASS */))
}